// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"82":"LazyThirdBonusRoundRoute","737":"LazySecondBonusRoundRoute","780":"FifthBonusRoundRoute","799":"FirstBonusRoundRoute","919":"FourthBonusRoundRoute"}[chunkId] || chunkId) + "." + {"82":"0332f0b6","488":"1de54e9c","737":"19ac18ee","780":"0711f384","799":"35017945","919":"443b07f5"}[chunkId] + ".chunk.js";
};